"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ospedaletto-lodigiano": {
    "42aaecf7": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-bonina": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b5f8f7fe": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-griona": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "470ac772": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-malpensata": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d048c80b": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-villafranca-di-mezzo": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca86430f": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-villafranca-di-sopra": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "953d2ba8": [{
      "hkey": "893a4b12",
      "slug": "cascina-mandella",
      "name": "Cascina Mandella",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-cascina-mandella": [{
      "hkey": "893a4b12",
      "slug": "cascina-mandella",
      "name": "Cascina Mandella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50ecc1bf": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-fontanone": [{
      "hkey": "99ae6c8c",
      "slug": "ospedaletto-lodigiano",
      "name": "Ospedaletto Lodigiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;